/**
 * Timings for Bring to Life (Track 2, fal.ai / Hailuo).
 *
 * These live apart from VideoGenContext deliberately. They are measurements
 * rather than behaviour, and keeping them here means a test can read them
 * without dragging in the whole editor context, Apollo and the modal.
 *
 * Background, SYM-5858: Bring to Life told customers their clip could not be
 * generated on generations that were running perfectly and went on to succeed.
 * One number was doing two jobs. The progress estimate also derived the
 * deadline, so an unmeasured "~60-90s" guess written for the progress bar
 * quietly became a 3 min 7.5 s deadline on a six minute render. The two values
 * below are therefore stated separately on purpose: changing how fast the bar
 * moves must never again change when the browser gives up.
 */

/**
 * How long a generation actually takes, end to end: the time 9 clips in 10
 * finish within, so the bar reaches its end for most customers just as their
 * clip lands, and the wait screen can say "40-60 seconds" truthfully.
 *
 * SYM-6524, 22 Oct 2026: fal H3 Max Turbo replaced Hailuo. Measured on QA
 * 20-22 Oct, click to finished clip, 7 clips: 15, 25, 27, 27 and 57 s, plus
 * two of 4 min 5 s and 9 min 39 s that waited for a free graphics card. That
 * wait is fixed (SYM-6525, render service v20/v21), so those two are left
 * out. Steven, 21 Oct 2026: show the 90% time rounded to a commercial figure,
 * "40-60 seconds", with the bar running to 60 s. Re-measure on production
 * after a week and adjust.
 *
 * Before that, Hailuo, MEASURED on QA 2026-09-24 (SYM-6339), every completed Bring to Life clip of
 * September, request to finished clip: 27 clips, median 1 min 41 s, 90% within
 * 2 min 56 s, slowest 7 min 56 s. It replaces the 6 minutes measured on two
 * clips on 2026-08-05 (25172: 5 min 50 s, 25173: 5 min 29 s).
 *
 * Only the progress bar reads this (5% to 85% over this time). Re-measure and
 * update the date if the provider or the model changes.
 */
export const BTL_OBSERVED_DURATION_MS = 60_000; // 60 s

/**
 * When the browser stops waiting and tells the customer the clip will appear
 * later.
 *
 * Comfortably clear of the measured duration above, because reaching it used
 * to produce a false failure on every single successful generation. It is a
 * client-side deadline only: the generation continues server-side either way
 * and attaches itself to the ad when it finishes, so erring long costs nothing
 * more than a spinner.
 */
export const BTL_POLLING_CEILING_MS = 900_000; // 15 min
